const ROOT_API = process.env.VUE_APP_ROOT_API;

const GET_MZL = ROOT_API + 'get_site_data/mzl/get_mzl.php';
const GET_MANUAL_MZL = ROOT_API + 'get_site_data/mzl/get_manual_mzl.php';
const GET_MANUAL_MZL_LIST = ROOT_API + 'get_site_data/mzl/get_manual_mzl_list.php';
const GET_CRITICAL_DENSITY_PARAMS = ROOT_API + 'get_site_data/mzl/get_critical_density_params.php';


import fetchData from '@/lib/fetchData';
import processJSON from '@/lib/processJSON';

export default {
	
	state: {
		mzl: null,
		manualMzl: null,
		manualMzlList: [],

		mzlIsLoading: false,

		mzlNoNeed: false,

		criticalDensityParams: {},
	},

	mutations: {
		setMzl(state, payload) {
			state.mzl = payload;
		},
		setManualMzl(state, payload) {
			state.manualMzl = payload;
		},
		setManualMzlList(state, payload) {
			state.manualMzlList = payload;
		},
		clearMzl(state) {
			state.mzl = null;
			state.manualMzl = null;
			state.manualMzlList = [];
		},
		setLoading(state, payload) {
			state.mzlIsLoading = payload;
		},

		setCriticalDensityParams(state, payload) {
			state.criticalDensityParams = Array.isArray(payload) && payload.length ?
																															payload[0] :
																															{};
		},
	},

	actions: {

		getCriticalDensityParams(context, payload) {
			const { rootState, commit } = context;

			const lpo_id = rootState.selectedLpo.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_CRITICAL_DENSITY_PARAMS, form).then(res => {
				commit('setCriticalDensityParams', res);
			});
		},

		getMzlFull(context, payload) {
			const { state, commit, dispatch } = context;

			commit('clearMzl');

			commit('setLoading', true);

			return dispatch('getMzl').then(res => {
				return dispatch('getManualMzl');
			}).then(res => {
				if (state.mzl && state.mzl.id === '-1') { // если ручной ввод
					return dispatch('getManualMzlList').then(res => { // получаем список для выбора
						if (state.manualMzl) { // если в базе сохранено значение
							const finded = state.manualMzlList.find(mzl => mzl.id === state.manualMzl.mzl_id);
							/* если в списке есть уже сохраненное в базе значение, все хорошо */
							/* иначе в базе неактуальное значение - удаляем его */
							if (!finded) {
								return dispatch('removeManualMzl', state.manualMzl.id).then(res => {
									commit('setManualMzl', null);
								});
							}
						}
					});
				}
			}).then(res => {
				if (state.mzl && state.mzl.id !== '-1') { // если не ручной ввод (расчитано автоматически)

					// commit('setManualMzl', [{ id: state.mzl.id, name: state.mzl.name }]);

					if (state.manualMzl) { // если в базе сохранено значение

						/* если это ВСР (512) и код = 0, значит мероприятие не требуется */	
						if (state.mzl.id === '512' && state.manualMzl.mzl_id === '0') {
							return;
						}

						/* иначе, удаляем это значение, ведь его не должно быть при автоматическом расчете */	
						return dispatch('removeManualMzl', state.manualMzl.id).then(res => {
							commit('setManualMzl', null);
						});
					}
				}
			}).finally(() => {
				commit('setLoading', false);
			});
		},

		getMzl(context, payload) {
			const { rootState, commit } = context;

			const lpo_id = rootState.selectedLpo?.lpo ? rootState.selectedLpo.lpo.lpo_id: payload.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_MZL, form).then(res => {
				if (res.length) {
					commit('setMzl', res[0]);
				}
			});
		},

		getManualMzl(context, payload) {
			const { rootState, commit } = context;

			const lpo_id = rootState.selectedLpo?.lpo ? rootState.selectedLpo.lpo.lpo_id: payload.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_MANUAL_MZL, form).then(res => {
				if (res.length) {
					commit('setManualMzl', res[0]);
				}
			});
		},

		getManualMzlList(context, payload) {
			const { rootState, commit } = context;

			const lpo_id = rootState.selectedLpo.lpo.lpo_id;

			const form = new FormData();
			form.append('lpo_id', lpo_id);

			return fetchData(GET_MANUAL_MZL_LIST, form).then(res => {
				commit('setManualMzlList', res);
			});
		},

		saveManualMzl(context, mzl_id) {
			const {state,  rootState } = context;
			let jsonDel = [];
			if(state.manualMzl) {
				jsonDel = [
					{
						'tab_name': 'data_lpo_mzl',
						'id': state.manualMzl.id,
					}
				]
			}

			const json_obj = [
				{
					'd': jsonDel,
					'i': {
						'tab': [
							{
								'tab_name': 'data_lpo_mzl',
								'f_v': {
									'parent_id': rootState.selectedLpo.lpo.lpo_id,
									'mzl_id': mzl_id,
									'is_neighbor': false
								}
							}
						]
					}
				}
			];

			const json_str = JSON.stringify(json_obj);

			return processJSON(json_str);
		},

		toggleNoNeed(context, checked) {
			const { state, rootState, commit } = context;

			let json_obj = null;

			if (!checked && state.manualMzl) {

				json_obj = [
					{
						'd': [
							{
								'tab_name': 'data_lpo_mzl',
								'id': state.manualMzl.id,
							}
						]
					}
				];

			} else if (checked && !state.manualMzl) {

				json_obj = [
					{
						'i': {
							'tab': [
								{
									'tab_name': 'data_lpo_mzl',
									'f_v': {
										'parent_id': rootState.selectedLpo.lpo.lpo_id,
										'mzl_id': '0',
										'is_neighbor': false
									}
								}
							]
						}
					}
				];
			}
			
			if (!json_obj) {
				return;
			}

			const json_str = JSON.stringify(json_obj);

			commit('setLoading', true);

			return processJSON(json_str).finally(() => {
				commit('setLoading', false);
			});
		},

		toggleInstrumRecommended(context, payload) {
			const { state, rootState, commit } = context;

			const { checked, mzlValue } = payload;

			// console.log(payload);
			// return;

			let json_obj = null;

			if (!checked && mzlValue) {

				json_obj = [
					{
						'd': [
							{
								'tab_name': 'data_lpo_mzl',
								'id': mzlValue.id,
							}
						]
					}
				];

			} else if (checked && !mzlValue) {

				json_obj = [
					{
						'i': {
							'tab': [
								{
									'tab_name': 'data_lpo_mzl',
									'f_v': {
										'parent_id': rootState.selectedLpo.lpo.lpo_id,
										'mzl_id': '370',
										'is_neighbor': false
									}
								}
							]
						}
					}
				];
			}
			
			if (!json_obj) {
				return;
			}

			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			commit('setLoading', true);

			return processJSON(json_str).finally(() => {
				commit('setLoading', false);
			});
		},

		removeManualMzl(context, data_lpo_mzl_id) {
			const json_obj = [
				{
					'd': [
						{
							'tab_name': 'data_lpo_mzl',
							'id': data_lpo_mzl_id
						}
					]
				}
			];

			const json_str = JSON.stringify(json_obj);

			return processJSON(json_str);
		},

		toggleFellOnlyFelling(context, payload) {
			const { state, rootState } = context;

			const value = payload;

			const json_obj = [
				{
					'u': [
						{
							'tab_name': 'data_lpo',
							'f_v': {
								'id': rootState.selectedLpo.lpo.lpo_id,
								'is_fell_only_felling': value
							}
						}
					]
				}
			];
			const json_str = JSON.stringify(json_obj);
			// console.log(json_str);
			// return;

			return processJSON(json_str);
		},

	}
};